/*

? First, let's import the interface that will describe the shape of our services object.

*/

import StateInterface from "../state-interface";

export const delete_account: StateInterface["delete_account"] = {
	_id: "62e4dcc7893a5fc8c8b287c4",
	user_id: "62e4dcc7893a5fc8c8b287c4",
	created_by: {
		user_id: "62e4dcc7893a5fc8c8b287c4",
		is_business_profile: true,
		business_profile_id: "62e4dcc7893a5fc8c8b287c4",
	},
	expiers_at: new Date(new Date().getTime() + 30 * 24 * 60 * 60 * 1000), // 30 days from now
	updated_at: new Date(),
	created_at: new Date(),
};
